import { StandardFrame } from "@/components/ui/frames/standard-frame";
import { useSiegeMapClears } from "@/hooks/queries/use-siege";
import { useSPAContext } from "@/providers/spa-provider";
import { RouteNames } from "@/types/route-names";
import {
  SIEGE_CAMPAIGN,
  SIEGE_REGIONS,
} from "game/data/siege-maps/siege-campaign";
import {
  isRegionCleared,
  isRegionUnlocked,
} from "game/data/siege-maps/region-progress";
import { shouldUnlockAllRegions } from "@/views/siege/world-map/should-unlock-all-regions";

export const PlayMenuCampaignTeaser = () => {
  const { setCurrentRoute } = useSPAContext();
  const { data: clears = [] } = useSiegeMapClears();

  const total = SIEGE_CAMPAIGN.length;
  const cleared = clears.length;
  const pct = total > 0 ? Math.round((cleared / total) * 100) : 0;

  const nextRegion =
    SIEGE_REGIONS.find(
      (r) =>
        (shouldUnlockAllRegions() ||
          isRegionUnlocked(r, SIEGE_CAMPAIGN, clears)) &&
        !isRegionCleared(r.id, SIEGE_CAMPAIGN, clears),
    ) ?? SIEGE_REGIONS.find((r) => !r.unlocked_by.length);

  return (
    <StandardFrame
      variant="night"
      rounded
      onClick={() => setCurrentRoute(RouteNames.SIEGE)}
      className="cursor-pointer active:brightness-110"
    >
      <div className="flex items-center gap-3 px-3 py-2">
        <span className="text-lg leading-none" aria-hidden>
          🏰
        </span>
        <div className="flex-1 min-w-0 flex flex-col gap-1">
          <div className="flex items-baseline justify-between gap-2">
            <span className="text-white font-black text-xs truncate drop-shadow-sm">
              {nextRegion?.name ?? "Campaign"}
            </span>
            <span className="text-pk-gray-4 font-black text-[10px] tabular-nums shrink-0">
              {cleared}/{total}
            </span>
          </div>
          <div className="w-full bg-pk-night-2 border border-black h-2 overflow-hidden">
            <div
              className="h-full bg-pk-blue-5 transition-all"
              style={{ width: `${pct}%` }}
            />
          </div>
        </div>
        <span className="text-pk-gray-4 text-[10px] font-black">▸</span>
      </div>
    </StandardFrame>
  );
};
